module.exports = __webpack_public_path__ + "media/neige.24d00bad.mp4";